export default {"src":"/_next/static/media/member-using-app-blue.colour.95e81616.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};